import { useState } from "react";
import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import {
    useCreateThirdPartyProviderNotesMutation,
    useDeleteProviderNoteByIdMutation,
    useGetNotesByProviderIdQuery
} from "../thirdPartyProvider";
import CommonNotesForm from "../../../../components/common/CommonNotesGrid/CommonNotesGrid";
import NotesUpdateOrAddModal from "../../../../components/common/CommonNotesGrid/NoteAddOrUpdateModal";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";



const ThirdPartyProviderNotesForm = () => {

    const { providerId } = useParams();
    const [showAddModal, setShowshowAddModal] = useState(false);
    const [noteBody, setNoteBody] = useState<string>("");
    const [deleteNotes, { isLoading }] = useDeleteProviderNoteByIdMutation();
    const [createNotesApi, createNotesApiResp] = useCreateThirdPartyProviderNotesMutation();

    const {
        data: notesData,
        isLoading: loading,
        isError: error,
    } = useGetNotesByProviderIdQuery(providerId || skipToken);

    const handleDelete = async (noteId: string) => {
        if (noteId) {
            await deleteNotes(noteId).unwrap();
        }
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const noteDto = {
            message: noteBody,
            thirdPartyProviderId: providerId

        };
        if (noteBody) {
            await handleRTKQuery(
                async () => {
                    return await createNotesApi({ id: providerId, requestBody: noteDto }).unwrap();
                },
                (isSuccess: boolean) => {
                    if (isSuccess) {
                        setShowshowAddModal(false);
                    }
                    setNoteBody("")
                }
            );
        }
    }

    return (
        <>
            <CommonNotesForm
                data={notesData}
                title="Third Party Provider Notes"
                type="ThirdParty"
                count={notesData?.length || 0}
                setShow={setShowshowAddModal}
                handleDelete={handleDelete}
                isLoading={isLoading}
                addPermissions={hasPermission(["HOATPP-U"])}
                deletePermissions={hasPermission(["HOATPP-D"])}
            />


            {showAddModal &&
                <NotesUpdateOrAddModal title={"Add Third Party Provider Notes"}
                    show={showAddModal}
                    setShow={setShowshowAddModal}
                    relationalId={providerId}
                    type={"ThirdParty"}
                    length={notesData && notesData.length + 1}
                    btnName="Add" setNoteBody={setNoteBody} noteBody={noteBody}
                    handleSubmit={handleSubmit} isLoading={createNotesApiResp.isLoading} />
            }
        </>
    );
};

export default ThirdPartyProviderNotesForm;
